<template>

    <Delivery :entity-type="BUSINESS_TYPE.GROCER" />

</template>

<script>
    import Delivery from '@/components/delivery/DeliverySettings';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityDeliverySettings',

        components: {
            Delivery,
        },
  
        data () {
            return {
                BUSINESS_TYPE
            }
        },
    
        computed: {},

        mounted() {},

        methods: {}
    }
</script>
